(function () {
  if (window.__collectionCardMediaInit) return;
  window.__collectionCardMediaInit = true;

  function advanceMedia(media, dir) {
    var imgs = media.querySelectorAll('.collection-card__image');
    if (imgs.length < 2) return;
    var activeIndex = 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].classList.contains('is-active')) { activeIndex = i; break; }
    }
    var nextIndex = (activeIndex + dir + imgs.length) % imgs.length;
    imgs[activeIndex].classList.remove('is-active');
    imgs[nextIndex].classList.add('is-active');
    // Keep the hover-preview pointing at "current + 1" so hovering
    // after a click continues to preview the *next* media item.
    var hoverIndex = (nextIndex + 1) % imgs.length;
    for (var k = 0; k < imgs.length; k++) imgs[k].classList.remove('is-hover-next');
    imgs[hoverIndex].classList.add('is-hover-next');
    var dots = media.querySelectorAll('[data-collection-card-dots] .collection-card__dot');
    for (var d = 0; d < dots.length; d++) {
      dots[d].classList.toggle('is-active', d === nextIndex);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-collection-card-prev], [data-collection-card-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var media = btn.closest('[data-collection-card-media]');
    if (!media) return;
    advanceMedia(media, btn.hasAttribute('data-collection-card-next') ? 1 : -1);
  }, true);

  // Mobile swipe support (≤768px). Horizontal drag on the media box
  // cycles images; vertical drag is left alone so page scroll works.
  // Desktop uses hover + arrow clicks already bound above.
  var swipeState = null;
  document.addEventListener('touchstart', function (e) {
    if (window.innerWidth > 768) return;
    if (e.touches.length !== 1) return;
    var media = e.target.closest('[data-collection-card-media]');
    if (!media) return;
    swipeState = {
      media: media,
      startX: e.touches[0].clientX,
      startY: e.touches[0].clientY,
      isSwipe: false
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!swipeState) return;
    var dx = e.touches[0].clientX - swipeState.startX;
    var dy = e.touches[0].clientY - swipeState.startY;
    if (!swipeState.isSwipe && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
      swipeState.isSwipe = true;
    }
    // Once committed to horizontal, cancel scroll hijack so the page
    // doesn't scroll while the user is swiping the card.
    if (swipeState.isSwipe && e.cancelable) {
      e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!swipeState) return;
    var state = swipeState;
    swipeState = null;
    if (!state.isSwipe) return;
    var dx = e.changedTouches[0].clientX - state.startX;
    if (Math.abs(dx) < 40) return;
    advanceMedia(state.media, dx < 0 ? 1 : -1);
    // Suppress the synthetic click the touch sequence would fire,
    // otherwise the swipe navigates to the PDP.
    state.media.__suppressNextClick = true;
    setTimeout(function () { state.media.__suppressNextClick = false; }, 400);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var media = e.target.closest('[data-collection-card-media]');
    if (!media || !media.__suppressNextClick) return;
    media.__suppressNextClick = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  function getSectionKeys() {
    // Always refresh the header cart count bubble; the drawer/notification
    // sections are added only when their elements are actually in the DOM.
    var keys = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) keys.push('cart-drawer');
    if (document.querySelector('cart-notification')) keys.push('cart-notification');
    return keys;
  }

  function updateCartIconBubble(response) {
    var html = response.sections && response.sections['cart-icon-bubble'];
    if (!html) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (section) bubble.innerHTML = section.innerHTML;
  }

  function handleCartOpen(response) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-card-atc', cartData: response });
    }

    // Keep the header count in sync even when the drawer/notification re-render
    // path is skipped (e.g. drawer mode with the cart icon counter in the header).
    updateCartIconBubble(response);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var finishDrawerOpen = function () {
        var html = response.sections && response.sections['cart-drawer'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            // Sync the outer class list too — Dawn toggles `is-empty` on the
            // <cart-drawer> element itself when the cart state changes, and
            // replacing only innerHTML leaves that stale class in place, so
            // the drawer keeps hiding line items until the next page load.
            if (fresh.className) drawer.className = fresh.className;
          }
        }
        if (typeof drawer.open === 'function') drawer.open();
      };

      if (typeof window.ensureCartDrawerScripts === 'function') {
        window.ensureCartDrawerScripts().then(finishDrawerOpen).catch(finishDrawerOpen);
      } else {
        finishDrawerOpen();
      }
      return;
    }
    var notif = document.querySelector('cart-notification');
    if (notif) {
      var html2 = response.sections && response.sections['cart-notification'];
      if (html2) {
        var tmp2 = document.createElement('div');
        tmp2.innerHTML = html2;
        var fresh2 = tmp2.querySelector('cart-notification');
        if (fresh2) notif.innerHTML = fresh2.innerHTML;
      }
      if (typeof notif.open === 'function') notif.open();
    }
  }

  function closeAllVariantPopovers(except) {
    document.querySelectorAll('[data-collection-card-atc-wrap][data-open="true"]').forEach(function (w) {
      if (w === except) return;
      w.setAttribute('data-open', 'false');
      var trg = w.querySelector('[data-collection-card-atc-trigger]');
      if (trg) trg.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-collection-card-atc-trigger]');
    if (trigger) {
      e.preventDefault();
      var wrap = trigger.closest('[data-collection-card-atc-wrap]');
      if (!wrap) return;
      var isOpen = wrap.getAttribute('data-open') === 'true';
      closeAllVariantPopovers(wrap);
      wrap.setAttribute('data-open', isOpen ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      return;
    }
    if (!e.target.closest('[data-collection-card-atc-wrap]')) {
      closeAllVariantPopovers(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllVariantPopovers(null);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-collection-card-atc]');
    if (!btn) return;
    if (btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    e.preventDefault();

    btn.classList.add('loading');
    btn.setAttribute('disabled', '');

    var sectionKeys = getSectionKeys();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionKeys.length) body.sections = sectionKeys;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function (response) {
        btn.classList.remove('loading');
        btn.removeAttribute('disabled');
        closeAllVariantPopovers(null);
        handleCartOpen(response);
      })
      .catch(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('disabled');
      });
  });

  // Notify Me (out-of-stock cards). The button is an <a href="…#notify-me">;
  // its real job is to open the Omnisend back-in-stock teaser, mirroring the
  // PDP — NOT to navigate. Lives here (not in a per-section script) so every
  // surface that renders a collection card (collection grid, related products,
  // recently viewed) gets the behavior. Sections that know the form id expose
  // it via window.__omnisendNotifyId for precise targeting; otherwise we fall
  // back to the first Omnisend teaser in the DOM. When neither an id nor a
  // teaser exists we let the native PDP navigation proceed as a no-JS fallback.
  function findNotifyTeaser() {
    var id = window.__omnisendNotifyId;
    if (id) return document.getElementById('omnisend-form-' + id + '-teaser-btn');
    return document.querySelector('[id^="omnisend-form-"][id$="-teaser-btn"]');
  }

  function dispatchTeaserClick(teaser) {
    teaser.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  }

  document.addEventListener('click', function (e) {
    var notifyBtn = e.target.closest('.collection-card__atc-btn--notify');
    if (!notifyBtn) return;
    var teaser = findNotifyTeaser();
    if (!teaser && !window.__omnisendNotifyId) return;
    e.preventDefault();
    if (teaser) { dispatchTeaserClick(teaser); return; }
    // Form id known but teaser may inject after load (Omnisend script timing).
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      var late = findNotifyTeaser();
      if (late) { clearInterval(iv); dispatchTeaserClick(late); return; }
      if (attempts >= 20) {
        clearInterval(iv);
        console.warn('[collection-card notify] Omnisend teaser for id "' + window.__omnisendNotifyId + '" not found. Check the form\'s display rules.');
      }
    }, 100);
  });
})();
